export default __webpack_public_path__ + "media/zurb/img/development-process/qa_sheet-9618b5173c4efba3999c9e2a1836eb57.png";